import React from 'react';

export default function ArrowBottomIcon() {
  return (
    <svg
      className="icon icon-arrow-bottom"
      xmlns="http://www.w3.org/2000/svg"
      width="9.5"
      height="4.93"
      viewBox="0 0 9.5 4.93"
    >
      <polygon points="4.75 4.93 0 0.75 0.66 0 4.75 3.6 8.84 0 9.5 0.75 4.75 4.93" fill="#c1c1c1" />
    </svg>
  );
}
